export enum AwardProgramImportStatus {
  Pending = 1,
  UnderValidation = 2,
  Processing = 3,
  Success = 4,
  Failed = 5
}


